import { Link } from 'react-router';
import { Image } from '../../../common/components/Image';
import { SponsorCardFormData } from './contracts';

export type SponsorCardProps = SponsorCardFormData;

function SponsorCard({ dataConfig: { name, imageSrc, url }, showTitle, openInNewTab }: SponsorCardFormData) {
  const image = (
    <Image
      className="sponsor-card__image"
      src={imageSrc}
      alt={name}
      width={0}
      height={0}
      sizes="100vw" // Adjusts the image size responsively
      style={{ width: 'auto', height: 'auto' }}
    />
  );

  return (
    <div className={'sponsor-card'}>
      {showTitle && <h4 className="sponsor-card__name">{name}</h4>}
      <div className="sponsor-card__image-wrapper">
        {url ? (
          <Link className="sponsor-card__link" to={url} target={openInNewTab ? '_blank' : '_self'}>
            {image}
          </Link>
        ) : (
          image
        )}
      </div>
    </div>
  );
}

export default SponsorCard;
